"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var CartContext = (0, preact_1.createContext)(null);
exports.default = CartContext;
